import { render, staticRenderFns } from "./manualList.vue?vue&type=template&id=c6abbd7a&scoped=true"
import script from "./manualList.vue?vue&type=script&lang=js"
export * from "./manualList.vue?vue&type=script&lang=js"
import style0 from "./manualList.vue?vue&type=style&index=0&id=c6abbd7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6abbd7a",
  null
  
)

export default component.exports